import styles from "./PlayLogs.module.css"
import { HeaderTable3 } from "../../components/content/table/header-table-3"
import { PLayLogsTableLine } from "./playlogs-table-line"
import { useEffect, useState } from "react"
import moment from "moment"
import { Playlogs, usePlaylogs } from "./lib/playlogs"
import { Spinner } from "flowbite-react"
import { useStorePlayLogs } from "./store"
import { useStoreShared } from "../../store"
import { setPlayLogs } from "./store/actions"
interface Props {
  serviceName?: string
}
function PlayLogs(props: Props) {
  const { dispatchPlayLogs } = useStorePlayLogs()
  const { stateShared } = useStoreShared()
  const [clearPlayer, setClearPlayer] = useState(false)
  const [paramsPlaylogs] = useState({
    $page: 1,
    $length: 200,
    endTime: moment().format("YYYY-MM-DD") + "T23%3A59%3A59%2B0200",
    startTime: moment().subtract(1, "days").format("YYYY-MM-DD") + "T00%3A00%3A00%2B0200",
  })
  const [playlogs, , ,] = usePlaylogs(stateShared.currentClient?.uuid, props.serviceName, paramsPlaylogs)

  useEffect(() => {
    if (playlogs.length > 0) {
      dispatchPlayLogs(setPlayLogs(playlogs))
    }
  }, [playlogs])

  function changeStatus(value: any) {
    setClearPlayer(value)
  }

  return (
    <div className={styles.root}>
      <HeaderTable3 title={["Title & Time", "Preview"]}></HeaderTable3>
      {playlogs && <div className={styles.centerScreen}>{playlogs.length === 0 && <Spinner size="xl"></Spinner>}</div>}
      {playlogs &&
        playlogs.map((playlog: Playlogs, index: number) => {
          return (
            <span key={index}>
              {" "}
              <PLayLogsTableLine
                togglePlay={clearPlayer}
                playing={changeStatus}
                className={index % 2 === 0 ? styles.bg : ""}
                playlog={playlog}
                serviceName={props.serviceName}
              ></PLayLogsTableLine>
            </span>
          )
        })}
      <br />
    </div>
  )
}

export default PlayLogs
